export default __webpack_public_path__ + "static/media/bg-video.11534cb6.mp4";